module.exports = __webpack_public_path__ + "assets/img/season-code-01-949bcebc.png";